/** Roles that grant access to admin/supervisor-only navigation items and features. */
export const ADMIN_ROLES = ['admin', 'supervisor'];

/** Filter items by required roles. Items without requiredRoles are always visible. */
export function filterByRoles<T extends { requiredRoles?: string[] }>(
  items: T[],
  userRoles: string[],
): T[] {
  return items.filter(
    (item) => !item.requiredRoles || item.requiredRoles.some((r) => userRoles.includes(r)),
  );
}
